import styled from "styled-components";

import { typography } from "globalConstants";
import { Default } from "Types";
import { Atoms } from "Types/Components";

export type PropsType = Atoms.H2;

const Wrap = styled.h2<Default>`
   ${typography.other.h2}
   overflow-wrap: break-word;
   word-break: keep-all;
   ${({ css }) => css}
`;

export default function H2(props: PropsType) {
   return <Wrap {...props}>{props.children}</Wrap>;
}
